import axiosInstance from "../AxiosInstance";
import {
  ACTIVE_FLAG_POSTING_LIST,
  ADS_LIMIT,
  BLOCK_USER,
  DASHBOARD,
  FLAG_POSTING_LIST,
  FLAT_LIST,
  JOB_CATEGORY_LIST,
  JOB_DETAILS,
  JOB_POSTING_LIST,
  PRICE,
  SERVICE_CATEGORY_LIST,
  SERVICE_DETAILS,
  SERVICE_POSTING_LIST,
  USER_DASHBOARD,
  USER_DETAIL,
  USER_EVENT,
  USER_SUB_EVENTS,
  USER_TASKS,
  USERDETAIL,
  USERLIST,
  WAIT_LIST,
  CONTACT_US,
  UPLOAD_FILE,
  EDIT_ADS,
  DELETED_USERS,
  ADS_CITY,
  ROLE,
  ROLES,
  EXPORT_WAITLIST,
  SUBADMIN,
  RESET_PASSWORD,
  SUBADMINS,
  USERPROFILE,
  MIS,
  SAFETY_CHECK,
  REPORTED_CHATS,
  BLOCKED_CHATS,
  USER_CHAT,
  LIFECYCLE,
  INTRESETED_ADS,
  BOOKING_LIST,
  EXPRESSED_INTEREST,
  EXPORT_USER_LIST_DATA,
  EXPORT_SAFETY_CHECK_LIST,
  EXPORT_EXPRESS_INTEREST_BOOKING_LIST,
  FACE_VERIFY_PENDING_USER,
  VERIFY_USER,
  ADS_EXPORT_LIST
} from "./UserEndpoint";

export function getUserList(page, limit, startDate, endDate, type, search, lat, long) {
  return axiosInstance.get(`${USERLIST}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&${type ? `filter=${type}` : ""}&${search ? `search=${search}` : ""}&${lat ? `lat=${lat}` : ""}&${long ? `long=${long}` : ""}`);
}
export function getFaceVerifyPendingUser(page, limit, startDate, endDate, search, lat, long) {
  return axiosInstance.get(`${FACE_VERIFY_PENDING_USER}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&${search ? `search=${search}` : ""}&${lat ? `lat=${lat}` : ""}&${long ? `long=${long}` : ""}`);
}
export function getMISList(page, limit, startDate, endDate, type, search, lat, long) {
  return axiosInstance.get(`${MIS}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&${type ? `filter=${type}` : ""}&${search ? `search=${search}` : ""}&${lat ? `lat=${lat}` : ""}&${long ? `long=${long}` : ""}`);
}
export function getUserList2(page, limit, type, search) {
  return axiosInstance.get(`${USERLIST}?page=${page}&limit=${limit}&${type ? `filter=${type}` : ""}&${search ? `search=${search}` : ""}`);
}
export function getContactUs(page, limit, search) {
  return axiosInstance.get(`${CONTACT_US}?page=${page}&limit=${limit}&${search ? `search=${search}` : ""}`);
}
export function deletedUsers(page, limit) {
  return axiosInstance.get(`${DELETED_USERS}?page=${page}&limit=${limit} `);
}


export function getUserDetail(id) {
  return axiosInstance.get(`${USERDETAIL}?id=${id}`);
}


export function getUserEvent(id) {
  return axiosInstance.get(`${USER_EVENT}?userId=${id}`);
}


export function getUserSubEvent(id1, id2) {
  return axiosInstance.get(`${USER_SUB_EVENTS}?userId=${id1}&eventId=${id2}`);
}


export function getUserTasks(id1, id2) {
  return axiosInstance.get(`${USER_TASKS}?userId=${id1}&eventId=${id2}`);
}

export function getDashboardTemp() {
  return axiosInstance.get(`${USER_DASHBOARD}`);
}





// export function getUserSubEvent(id1, id2) {
//   return axiosInstance.post(`${USER_SUB_EVENTS}`, {
//     userId: id1,
//     eventId: id2
//   });
// }





export function getJobCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${JOB_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getServiceCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${SERVICE_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function postJobCategory(postData) {
  return axiosInstance.post(
    JOB_CATEGORY_LIST,
    postData
  );
}

export function postServiceCategory(postData) {
  return axiosInstance.post(
    SERVICE_CATEGORY_LIST,
    postData
  );
}

export function deleteJobCategory(id) {
  return axiosInstance.delete(
    `${JOB_CATEGORY_LIST}?categoryId=${id}`
  );
}

export function deleteServiceCategory(id) {
  return axiosInstance.delete(
    `${SERVICE_CATEGORY_LIST}?categoryId=${id}`
  );
}

export function updateJobCategory(postData) {
  return axiosInstance.put(
    `${JOB_CATEGORY_LIST}`,
    postData
  );
}

export function updateServiceCategory(postData) {
  return axiosInstance.put(
    `${SERVICE_CATEGORY_LIST}`,
    postData
  );
}

export function jobPostingData(currentPage, search) {
  return axiosInstance.get(
    `${JOB_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function flagPostingData(currentPage) {
  return axiosInstance.get(
    `${FLAG_POSTING_LIST}?page=${currentPage}`
  );
}

export function activeJobServicePostingData(data) {
  return axiosInstance.put(
    `${ACTIVE_FLAG_POSTING_LIST}`, data
  );
}

export function deleteJobPostingData(id) {
  return axiosInstance.delete(
    `${JOB_POSTING_LIST}?jobId=${id}`
  );
}

export function servicePostingData(currentPage, search) {
  return axiosInstance.get(
    `${SERVICE_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function deleteServicePostingData(id) {
  return axiosInstance.delete(
    `${SERVICE_POSTING_LIST}?serviceId=${id}`
  );
}

export function getJobDetails(id) {
  return axiosInstance.get(`${JOB_DETAILS}?jobId=${id}`);
}

export function getServiceDetails(id) {
  return axiosInstance.get(`${SERVICE_DETAILS}?serviceId=${id}`);
}

export function blockUser(data) {
  return axiosInstance.post(`${BLOCK_USER}`, data);
}

export function getPrice() {
  return axiosInstance.get(`${PRICE}`);
}

export function getDashboard(startDate, endDate) {
  return axiosInstance.get(`${DASHBOARD}?${startDate ? `startDate=${startDate}` : ""}&${endDate ? `endDate=${endDate}` : ""}`);
}

export function updatePrice(data) {
  return axiosInstance.put(`${PRICE}`, data);
}


export function getWaitList(page, limit, search) {
  return axiosInstance.get(
    `${WAIT_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getFlatList(page, limit, expiry, type, adType, user, lat, long, rentalStatus) {
  return axiosInstance.get(
    `${FLAT_LIST}?page=${page}&limit=${limit}&${expiry ? `expireStatus=${expiry}` : ""}&${type ? `status=${type}` : ""}&${adType ? `adType=${adType}` : ""}&${user ? `userId=${user}` : ""}&${lat ? `lat=${lat}` : ""}&${long ? `long=${long}` : ""}&${rentalStatus ? `rentalStatus=${rentalStatus}` : ""}`
  );
}
export function addAdsLimit(payload) {
  return axiosInstance.put(`${ADS_LIMIT}`, payload);
}
export function getUserById(id) {
  return axiosInstance.get(`${USER_DETAIL}?id=${id}`);
}

export function uploadFile(data) {
  return axiosInstance.put(`${UPLOAD_FILE}`, data);
}

export function updateAds(data) {
  return axiosInstance.put(`${EDIT_ADS}`, data);
}


export function getAdsByCity(page, limit, city) {
  return axiosInstance.get(`${ADS_CITY}?page=${page}&limit=${limit}&city=${city}`);
}

export function getUserRole(page, limit) {
  return axiosInstance.get(`${ROLES}?page=${page}&limit=${limit}`);
}

export function createUserRole(payload) {
  return axiosInstance.post(`${ROLE}`, payload);
}


export function updateUserRole(payload) {
  return axiosInstance.put(`${ROLE}`, payload);
}

export function deleteUserRole(id) {
  return axiosInstance.delete(`${ROLE}?id=${id}`);
}


export function getSubadmins(page, limit) {
  return axiosInstance.get(`${SUBADMINS}?page=${page}&limit=${limit}`);
}

export function createSubadmins(payload) {
  return axiosInstance.post(`${SUBADMIN}`, payload);
}



export function updateSubadmins(payload) {
  return axiosInstance.put(`${SUBADMIN}`, payload);
}



export function deleteSubadmins(id) {
  return axiosInstance.delete(`${SUBADMIN}?id=${id}`);
}

export function getUserData() {
  return axiosInstance.get(`${USERPROFILE}`);
}


export function getSafetyChecks(page, limit, status) {
  return axiosInstance.get(`${SAFETY_CHECK}?page=${page}&limit=${limit}&${status ? `status=${status}` : ""}`);
}

export function getReportedChats(page, limit) {
  return axiosInstance.get(`${REPORTED_CHATS}?page=${page}&limit=${limit}`);
}

export function getBLockedChats(page, limit) {
  return axiosInstance.get(`${BLOCKED_CHATS}?page=${page}&limit=${limit}`);
}


export function getUserChat(id) {
  return axiosInstance.get(`${USER_CHAT}?conversationId=${id}`);
}

export function resetSubadminPassword(payload) {
  return axiosInstance.put(`${RESET_PASSWORD}`, payload);
}
export function exportWaitList(startDate, endDate) {
  return axiosInstance.get(`${EXPORT_WAITLIST}?startDate=${startDate}&endDate=${endDate}`);
}
export function getLifecycle(id, page, limit) {
  return axiosInstance.get(`${LIFECYCLE}?userId=${id}&page=${page}&limit=${limit}`);
}
export function interestedAds(page, limit, lat, long, adType, user) {
  return axiosInstance.get(`${INTRESETED_ADS}?page=${page}&limit=${limit}&${lat ? `lat=${lat}` : ""}&${long ? `long=${long}` : ""}&${adType ? `adType=${adType}` : ""}&${user ? `userId=${user}` : ""}`);
}

export function bookedAds(id, page, limit, startDate, endDate) {
  return axiosInstance.get(`${BOOKING_LIST}?adId=${id}&page=${page}&limit=${limit}&${startDate ? `startDate=${startDate}` : ""}&${endDate ? `endDate=${endDate}` : ""}`);
}


export function expressedInterestUser(id, page, limit, startDate, endDate) {
  return axiosInstance.get(`${EXPRESSED_INTEREST}?adId=${id}&page=${page}&limit=${limit}&${startDate ? `startDate=${startDate}` : ""}&${endDate ? `endDate=${endDate}` : ""}`);
}

export function exportUsersListData(startDate, endDate, lat, long, filter = "Verified", status) {
  let url = `${EXPORT_USER_LIST_DATA}?startDate=${startDate}&endDate=${endDate}`;
  if (filter) url += `&filter=${filter}`;
  if (lat) url += `&lat=${lat}`;
  if (long) url += `&long=${long}`;
  if (status) url += `&status=${status}`;
  return axiosInstance.get(url);
}

export function exportSafetyCheckList(startDate, endDate, status) {
  let url = `${EXPORT_SAFETY_CHECK_LIST}?startDate=${startDate}&endDate=${endDate}`;
  if (status) url += `&status=${status}`;
  return axiosInstance.get(url);
}

export function exportExpressInterestBookingList(startDate, endDate, lat, long, adType, user) {
  let url = `${EXPORT_EXPRESS_INTEREST_BOOKING_LIST}?startDate=${startDate}&endDate=${endDate}`;
  if (lat) url += `&lat=${lat}`;
  if (long) url += `&long=${long}`;
  if (adType) url += `&adType=${adType}`;
  if (user) url += `&userId=${user}`;
  return axiosInstance.get(url);
}

export function verifyUser(payload) {
  return axiosInstance.put(`${VERIFY_USER}`, payload);
}

export function getAdsExportList(startDate, endDate, minPrice = "", maxPrice = "", furnishedType = "", bathroom = "", bedroom = "", adType = "", lat = "", long = "", expireStatus = "") {
  let url = `${ADS_EXPORT_LIST}?startDate=${startDate}&endDate=${endDate}`;
  if (minPrice !== undefined && minPrice !== null && minPrice !== "") url += `&minPrice=${encodeURIComponent(minPrice)}`;
  if (maxPrice !== undefined && maxPrice !== null && maxPrice !== "") url += `&maxPrice=${encodeURIComponent(maxPrice)}`;
  if (furnishedType) url += `&furnishedType=${encodeURIComponent(furnishedType)}`;
  if (bathroom !== undefined && bathroom !== null && bathroom !== "") url += `&bathroom=${encodeURIComponent(bathroom)}`;
  if (bedroom !== undefined && bedroom !== null && bedroom !== "") url += `&bedroom=${encodeURIComponent(bedroom)}`;
  if (adType) url += `&adType=${encodeURIComponent(adType)}`;
  if (lat) url += `&lat=${encodeURIComponent(lat)}`;
  if (long) url += `&long=${encodeURIComponent(long)}`;
  if (expireStatus) url += `&expireStatus=${encodeURIComponent(expireStatus)}`;
  return axiosInstance.get(url);
}